import collapse from "./collapseSlice"

export default {
  collapse
}
